import { MouseEvent } from "react";
import useLang from "Shared/hooks/useLanguage";

interface Props {
  url: string;
  onOpen: (url: string) => void;
}

// PDF icon: opens the file in the side panel's document viewer.
const ResultFileLink = ({ url, onOpen }: Props) => {
  const { t } = useLang();
  if (!url) return null;
  return (
    <button
      type="button"
      className="btn btn-icon btn-sm h-28px w-28px btn-active-light-danger"
      aria-label={t("View result file")}
      title={t("View result file")}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        onOpen(url);
      }}
    >
      <i className="bi bi-file-earmark-pdf text-danger fs-2"></i>
    </button>
  );
};

export default ResultFileLink;
